<template>
  <div class="d-flex flex-column w-100" id="AcuerdoLineasFormComponent">
    <!-- Tabla -->
    <div class="d-flex">
      <div class="w-20">
        <div class="Heading Cell">
          <p class="m-2">Naviera</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <ui-select
            style="font-size: 8px !important"
            class="w-75 mr-2 mt-1"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataListaNaviera"
            placeholder="Seleccione"
            has-search
            v-model="form.naviera_id.value"
            @change="getContracts(); navierasSalidaList()"
          ></ui-select>
        </div>
      </div>
      <div class="w-20">
        <div class="Heading Cell">
          <p class="m-2">Naviera Salida</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <ui-select
            style="font-size: 8px !important"
            class="w-75 mr-2 mt-1"
            :keys="{ value: 'id', label: 'name' }"
            :options="form.navieras_salida_list"
            placeholder="Seleccione"
            has-search
            v-model="form.naviera_salida.value"
          ></ui-select>
        </div>
      </div>
      <div class="w-25">
        <div class="Heading Cell">
          <p class="m-2">POL</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <ui-select
            style="font-size: 8px !important"
            class="w-75 mr-2 mt-1"
            :keys="{ value: 'id', label: 'name' }"
            :options="puertos"
            placeholder="Seleccione"
            v-model="form.pol.value"            
            has-search
          ></ui-select>
        </div>
      </div>
      <div class="w-25">
        <div class="Heading Cell">
          <p class="m-2">POD</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <ui-select
            style="font-size: 8px !important"
            class="w-75 mr-2 mt-1"
            :keys="{ value: 'id', label: 'name' }"
            :options="puertos"
            has-search
            placeholder="Seleccione"
            v-model="form.pod.value"
          ></ui-select>
        </div>
      </div>
      <div class="w-50">
        <div class="Heading Cell">
          <p class="m-2">Desde</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <date-picker
            class="w-100 mb-2 ml-1"
            style="margin-left: -2px; font-size: 22px"
            placeholder="Vigencia Término"
            type="date"
            value-type="format"
            v-model="form.from_date.value"
          />
        </div>
      </div>
      <div class="w-50">
        <div class="Heading Cell">
          <p class="m-2">Hasta</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <date-picker
            class="w-100 mb-2 ml-1"
            style="margin-left: -2px; font-size: 22px"
            placeholder="Vigencia Término"
            type="date"
            value-type="format"
            v-model="form.to_date.value"
          />
        </div>
      </div>
      <div class="w-25">
        <div class="Heading Cell">
          <p class="m-2">TT</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <ui-textbox
            style="font-size: 8px !important"
            class="w-50 mt-1"
            v-model="form.transit_time.value"
          ></ui-textbox>
        </div>
      </div>
      <div class="w-25">
        <div class="Heading Cell">
          <p class="m-2">Neta (Costo)</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <input 
            type="text" 
            class="text_field_mask w-75 ml-2 mt-1"
            v-mask="weightMaskNetPublic"
            v-model="form.neta.value"
            @change="cambiaValorDescuento()"
          />
          
        </div>
      </div>
      <div class="w-25">
        <div class="Heading Cell">
          <p class="m-2">Pública (Venta)</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">

          <input 
            type="text" 
            class="text_field_mask w-75 ml-2 mt-1"
            v-mask="weightMaskNetPublic"
            v-model="form.public_value.value"
            @change="cambiaValorDescuento()"
          />
          
        </div>
      </div>
      <div class="w-25">
        <div class="Heading Cell">
          <p class="m-2">Descuento</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <!--  -->
          <input 
            type="text" 
            class="text_field_mask w-75 ml-2 mt-1"
            v-mask="weightMask"
            v-model="discount"
            disabled
          />
          <!--  -->
        </div>
      </div>
      <div class="w-25">
        <div class="Heading Cell">
          <p class="m-2">Unidad</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <ui-select
            style="font-size: 8px !important"
            class="w-75 mt-1 mr-2"
            :keys="{ value: 'id', label: 'name' }"
            :options="filtroContenedores"
            placeholder="Seleccione"
            @change="filterAtmosphereByContainer"
            v-model="form.container_id.value">
          </ui-select>
        </div>
      </div>
      <div class="w-25">
        <div class="Heading Cell">
          <p class="m-2">Commodity</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <ui-select
            style="font-size: 8px !important"
            :keys="{ value: 'id', label: 'name' }"
            :options="filtroCommodity"
            has-search
            placeholder="Seleccione"
            class="mt-1"
            v-model="form.products_category_id.value"
          ></ui-select>
        </div>
      </div>
      <div class="w-25">
        <div class="Heading Cell">
          <p class="m-2">Atmósfera</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <ui-select
            style="font-size: 8px !important"
            class="w-100 mt-1 mr-2 ml-2"
            :keys="{ value: 'id', label: 'name' }"
            :options="atmosferasFiltradas"
            has-search
            placeholder="Seleccione"
            v-model="form.atmosphere_id.value"
          ></ui-select>
        </div>
      </div>
      <div class="w-25">
        <div class="Heading Cell">
          <p class="m-2">Trat. frío</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <ui-select
            style="font-size: 8px !important"
            class="w-75 mt-1"
            :keys="{ value: 'id', label: 'name' }"
            :options="filtroColdtreatment"
            has-search
            placeholder="Seleccione"
            v-model="form.coldtreatment.value"
          ></ui-select>
        </div>
      </div>
      <div class="w-25">
        <div class="Heading2 Cell d-flex align-items-center justify-content-center">
          <p class="m-2">FDO</p>
          <i title="Free Days Origen" style="cursor: pointer !important" class="fas fa-exclamation-circle"></i>
        </div>
        <div class="w-100 d-flex justify-content-center Cell Altura">
          <ui-textbox
            style="font-size: 8px !important"
            v-mask="weightMaskNaturalNumber"
            class="w-25 ml-1 mr-1 mt-1"
            v-model="form.free_days_embark.value"
          ></ui-textbox>
        </div>
      </div>
      <div class="w-25">
        <div class="Heading2 Cell d-flex align-items-center justify-content-center">
          <p class="m-2">PDO</p>
          <i title="Plug Days Origen" style="cursor: pointer !important" class="fas fa-exclamation-circle"></i>
        </div>
        <div class="w-100 d-flex justify-content-center Cell Altura">
          <ui-textbox
            style="font-size: 8px !important"
            v-mask="weightMaskNaturalNumber"
            class="w-25 ml-1 mr-1 mt-1"
            v-model="form.plug_days_embark.value"
          ></ui-textbox>
        </div>
      </div>
      <div class="w-25">
        <div class="Heading2 Cell d-flex align-items-center justify-content-center">
          <p class="m-2">FDD</p>
          <i title="Free Days Destino" style="cursor: pointer !important" class="fas fa-exclamation-circle"></i>

        </div>
        <div class="w-100 d-flex justify-content-center Cell Altura">
          <ui-textbox
            style="font-size: 8px !important"
            v-mask="weightMaskNaturalNumber"
            class="w-25 ml-1 mr-1 mt-1"
            v-model="form.free_days_land.value"
          ></ui-textbox>
        </div>
      </div>
      <div class="w-25">
        <div class="Heading2 Cell d-flex align-items-center justify-content-center">
          <p class="m-2">PDD</p>
          <i title="Plug Days Destino" style="cursor: pointer !important" class="fas fa-exclamation-circle"></i>
        </div>
        <div class="w-100 d-flex justify-content-center Cell Altura">
          <ui-textbox
            style="font-size: 8px !important"
            v-mask="weightMaskNaturalNumber"
            class="w-25 ml-1 mr-1 mt-1"
            v-model="form.plug_days_land.value"
          ></ui-textbox>
        </div>
      </div>
      <div class="w-25">
        <div class="Heading Cell">
          <p class="m-2">Genset</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <ui-checkbox
            box-position="right"
            style="color: gray"
            class="mt-3"
            align="center"
            v-model="form.genset.value"
          ></ui-checkbox>
        </div>
      </div>

      <div v-if="form.get_out" class="w-25">
        <div class="Heading Cell">
          <p class="m-2">Get Out</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <ui-checkbox
            box-position="right"
            style="color: gray"
            class="mt-3"
            align="center"
            v-model="form.get_out.value"
          ></ui-checkbox>
        </div>
      </div>

      <div class="w-25">
        <div class="Heading Cell">
          <p class="m-2">Tipo Contrato</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <ui-select
            style="font-size: 8px !important"
            class="w-75 mr-3 mt-1"
            :keys="{ value: 'id', label: 'name' }"
            :options="tipoContratos"
            placeholder="Seleccione"
            v-model="form.type_contract.value"
            @change="getContracts()"
          ></ui-select>
        </div>
      </div>
      <div class="w-100">
        <div class="Heading Cell">
          <p class="m-2">Contrato + Número</p>
        </div>
        <div class="d-flex justify-content-center Cell Altura">
          <ui-select
            has-search
            class="w-100 ml-1 mr-1 mt-1"
            :keys="{ value: 'id', label: 'name' }"
            :options="contracts"
            v-model="form.tariff_contract_id.value">
          </ui-select>
        </div>
      </div>
    </div>
    <div class="w-120">
      <div class="HeadingMitad Cell">
        <p class="m-2">Comentarios</p>
      </div>
      <div class="d-flex justify-content-center Cell Altura">
        <ui-textbox class="w-100 mr-4 ml-4 mt-1" v-model="form.comment.value" />
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";
import {
  getListasAcuerdosBase
} from "@/constants/lineas";
import { 
  getContratosPorNavieraYTipo 
} from "@/constants/lineas";
import { 
  mapState 
} from "vuex";
import { validateFormatDecimal } from '../../../../../mixins';
import createNumberMask from "text-mask-addons/dist/createNumberMask";


const weightMask = createNumberMask({
  prefix: "",
  suffix: "",
  allowDecimal: true,
  requireDecimal: false,
  includeThousandsSeparator: false,
  decimalSymbol: ".",
  decimalLimit: 2,
  integerLimit: 6,
});
const weightMaskNetPublic = createNumberMask({
  prefix: "",
  suffix: "",
  allowDecimal: true,
  requireDecimal: false,
  includeThousandsSeparator: false,
  decimalSymbol: ".",
  decimalLimit: 2,
  integerLimit: 6,
  allowNegative: true,
});

const weightMaskNaturalNumber = createNumberMask({
  prefix: "",
  suffix: "",
  allowDecimal: false,
  requireDecimal: false,
  includeThousandsSeparator: false,
  integerLimit: 2,
  allowNegative: false,

});

export default {
  props: [
    "form", "idContrato"
  ],
  data() {
    return {
      weightMask,
      weightMaskNetPublic,
      weightMaskNaturalNumber,
      recargos: [],
      containers: [],
      navieras: [],
      productos: [],
      discount: 0,
      contracts: [],
      filtroContenedores: [],
      filtroCommodity: [],
      filtroAtmosferas: [],
      filtroColdtreatment: [],
      atmosferasFiltradas: []
    };
  },
  components: {
    DatePicker,
  },
  computed: {
    ...mapState([
      "tipoContratos", "puertos", "atmosferas", "commodity"
    ]),
    ...mapState("lineas", [
      "dataListaNavierasNoUCC", "dataListaNaviera"
    ]),
  },
  methods: {
    navierasSalidaList() {

      if (this.form.naviera_id.value.name !== "UCC") {

        this.form.naviera_salida.value =  this.form.naviera_id.value;

        this.$set(this.form, 'navieras_salida_list', [this.form.naviera_id.value]);

      } else {

        this.$set(this.form, 'navieras_salida_list', this.dataListaNavierasNoUCC);

      }
    },
    fetchContainers: async function() {

      const { filtro_contenedores, lista_prod_categories, lista_atmosferas, lista_coldtreatment } = await getListasAcuerdosBase();

      this.filtroContenedores = filtro_contenedores.map((fc) => ({ id: fc.id, name: fc.code, ac: fc.ac }));
      this.filtroCommodity = lista_prod_categories;
      this.filtroAtmosferas = lista_atmosferas;
      this.filtroColdtreatment = lista_coldtreatment || [];

    },
    filterAtmosphereByContainer() {

      let containers = this.filtroAtmosferas;

      this.form.atmosphere_id.value = [];

      if (this.form.container_id.value.ac === 0) {

        this.atmosferasFiltradas = containers.filter(item => item.id === 13);

      } else {
        
        this.atmosferasFiltradas = containers.filter(item => item.id !== 13);
      }
    },
    async getContracts(){

      if( 
        this.form.naviera_id.value.id === undefined || this.form.naviera_id.value.id === "" 
      ) return ;
      if( this.form.type_contract.value.id === "" || this.form.type_contract.value.id === undefined ) return ;

      try {
        this.contracts = await getContratosPorNavieraYTipo({
          naviera_id: this.form.naviera_id.value.id,
          type: this.form.type_contract.value.id
        }) ;
  
        if( this.contracts.length === 0 ){
          this.contracts = [] ;  
        }
      } catch (error) {
        this.contracts = [] ;        
      }
    },
    init: function () {
      this.fetchContainers();
    },
    cambiaValorDescuento: function () {

      let descuento = 0 ;

      if( validateFormatDecimal( this.form.public_value.value ) && validateFormatDecimal( this.form.neta.value ) ){

        descuento = ( +this.form.public_value.value - +this.form.neta.value ) ;
      }

      this.discount = Number.isNaN( descuento ) ? 0 : descuento;
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    idContrato: function () {
      this.getContracts();
      this.cambiaValorDescuento();
    },
  },
};
</script>
<style>

#AcuerdoLineasFormComponent .text_field_mask {
  background: none;
  border: none;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-radius: 0;
  color: rgba(0, 0, 0, 0.87);
  cursor: auto;
  display: block;
  font-family: inherit;
  font-size: 1rem;
  font-weight: normal;
  margin: 0;
  outline: none;
  padding: 0;
  transition: border 0.1s ease;
  width: 100%;
  height: 32px;
}
.modal-editar-simple-acuerdo-linea .ui-modal__container {
  width: 100% !important;
  /* margin-right: 150% !important; */
}
.modal-agregar-acuerdo-linea .ui-modal__container {
  width: 100% !important;
  /* margin-right: 150% !important; */
}
.Heading {
  background-color: #ccccca;
  font-weight: bold;
  text-align: center;
  height: 50px;
}
.Heading2 {
  background-color: #ccccca;
  font-weight: bold;
  text-align: center;
  height: 50px;
  width: 70px;
}
.HeadingMitad {
  background-color: #ccccca;
  font-weight: bold;
  text-align: center;
  height: 40px;
}

.Cell {
  border: groove;
  border-width: thin;
}
.Altura {
  height: 60px;
}
.AlturaMitad {
  height: 30px;
}
.form-control.input-sm {
  height: 30px !important;
  min-width: auto !important;
}
</style>
